import React from 'react';
import ArtworkCard from './ArtworkCard';
import ArtworkSkeleton from '../ArtworkSkeleton';

export const DISCOVER_GRID_SIZE = 20;

const SKELETON_COUNT = 8;

const DiscoverArtworkGrid = ({
  artworks,
  liveViews = {},
  emptyMessage = 'No artworks match your filters.',
  isLoading = false,
}) => {
  if (isLoading) {
    return (
      <div className="overflow-visible py-4 sm:py-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-5 md:gap-6">
          {Array.from({ length: SKELETON_COUNT }).map((_, index) => (
            <ArtworkSkeleton key={index} />
          ))}
        </div>
      </div>
    );
  }

  if (artworks.length === 0) {
    return (
      <p className="text-center text-gray-500 py-16 text-sm sm:text-base">{emptyMessage}</p>
    );
  }

  const visibleArtworks = artworks.slice(0, DISCOVER_GRID_SIZE);
  const totalCount = artworks.length;

  return (
    <div className="overflow-visible py-4 sm:py-6">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-5 md:gap-6 overflow-visible">
        {visibleArtworks.map((artwork) => (
          <div
            key={artwork._id}
            className="relative z-0 transition-all duration-300 ease-out hover:z-30 hover:scale-[1.05]"
          >
            <ArtworkCard
              _id={artwork._id}
              slug={artwork.slug}
              title={artwork.title}
              artist={artwork.artist}
              image={artwork.imageUrl}
              views={liveViews[artwork._id] ?? artwork.views ?? 0}
              price={artwork.price}
              isVerified
              status={artwork.status}
            />
          </div>
        ))}
      </div>
      {totalCount > DISCOVER_GRID_SIZE && (
        <p className="text-center text-gray-500 text-sm mt-6">
          Showing {DISCOVER_GRID_SIZE} of {totalCount} works — refine filters to see more.
        </p>
      )}
    </div>
  );
};

export default DiscoverArtworkGrid;
